import { Injectable, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { __values } from 'tslib';


@Injectable({
  providedIn: 'root',
})
export class CommonService {

  constructor(private http: HttpClient) {
  }
  LoginOutlet
  userData: any
  userOutletCode(){
    this.userData = JSON.parse(this.atou(sessionStorage.getItem(environment.dataKey)));
    // console.log(JSON.parse(this.userData[0].registerdetail)[0]);
    
    return  this.LoginOutlet=JSON.parse(this.userData[0].registerdetail)[0].outletcode
  }
  userRegisterCode(){
    this.userData = JSON.parse(this.atou(sessionStorage.getItem(environment.dataKey)));
    return  this.LoginOutlet=JSON.parse(this.userData[0].registerdetail)[0].registercode
  }
  Role(){
    return JSON.parse(this.atou(sessionStorage.getItem(environment.dataKey)))[0].role
  }
  utoa(data) {
    return btoa(unescape(encodeURIComponent(data)));
  }
  atou(data) {
    return decodeURIComponent(escape(atob(data)));
  }
  roundOff(value:Number){
    return Number(value.toFixed(2));
  }
  handleError(error: HttpErrorResponse): Observable<any> {
    let message = null;
    // if (error.error instanceof ErrorEvent) {
    //   this.toastrService.error(`An error occurred: ${error.error.message}`);
    // } else {
    //   this.toastrService.error(`Backend returned code: ${error.status}, body was: ${error.error}`);
    // }
    // return throwError(this.toastrService.error('Something bad happened. Please try again later.'));
    return throwError(null);
  }
  Sweetalert(text,icon) {
    Swal.fire({
      text: text,
      imageHeight: 20,
      confirmButtonColor: '#556ee6',
      timerProgressBar:true,
      timer: 3000,
      showConfirmButton: false,
      toast: true,
      icon: icon,
      position: 'top-right',
    });
  }
ExcelData(data,Filename){
  this.download(data,Filename)
}
  download(data,Filename){
    const readyToExport = data

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(readyToExport);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
    XLSX.writeFile(workBook, Filename+'.xlsx'); // initiate a file download in browser

  }
notification(value)
{
  localStorage.setItem('notifications',value)
}
readnotification()
{
  return localStorage.getItem("notifications")
}
setYearData(storecode: string, callback?: () => void) {
  // Clear old yearData before fetching new
  sessionStorage.removeItem('yearData');
  return this.http.get<any[]>(`${environment.baseUrl}fa/year?storecode=${storecode}`).subscribe(years => {
    if (years && years.length > 0) {
      // Find the year where IsCurrentYear is true
      const year = years.find(y => y.IsCurrentYear === true);
      if (year) {
        const yearData = {
          YearId: year.YearId,
          YearNm: year.YearNm,
          FinYearFrom: year.FinYearFrom,
          FinYearTill: year.FinYearTill
        };
        sessionStorage.setItem('yearData', this.utoa(JSON.stringify(yearData)));
      }
    }
    if (callback) callback();
  });
}
getYearData() {
  const data = sessionStorage.getItem('yearData');
  return data ? JSON.parse(this.atou(data)) : null;
}
}


